module.exports = __webpack_public_path__ + "img/mefly-logo.5a360e70.svg";